@if (isAmountsReportingAllowed) {
    <div class="amount-counter">
        @if (operationData && formData) {
            <div class="amount-counter__container">
                <hdmui-key-value
                    class="hdmui-mb-3 hdmui-ms-0 hdmui-py-4"
                    [key]="'DC.REPORT_LAST_AMOUNTS.DIALOG.PLANNED_AMOUNT' | translate"
                    [wrapText]="true"
                >
                    {{ operationData.plannedGood | dynamicNumber }}
                </hdmui-key-value>
                <hdmui-key-value
                    class="hdmui-ms-0"
                    [ngClass]="{
                        exceeded: operationData.currentGood + formData.goodAmount > operationData.plannedGood,
                    }"
                    [class.subceeded]="
                        isFinishOperation && operationData.currentGood + formData.goodAmount < operationData.plannedGood
                    "
                    [key]="'DC.REPORT_LAST_AMOUNTS.DIALOG.ACCUMULATED_GOOD_AMOUNT' | translate"
                    [wrapText]="true"
                >
                    {{ operationData.currentGood + formData.goodAmount | dynamicNumber }}
                </hdmui-key-value>
                <hdmui-key-value
                    class="hdmui-mb-3 hdmui-ms-0 hdmui-py-2"
                    [key]="'DC.REPORT_LAST_AMOUNTS.DIALOG.ACCUMULATED_WASTE_AMOUNT' | translate"
                    [ngClass]="{
                        exceeded: operationData.currentWaste + formData.wasteAmount > operationData.plannedWaste,
                    }"
                    [wrapText]="true"
                >
                    {{ operationData.currentWaste + formData.wasteAmount | dynamicNumber }}
                </hdmui-key-value>
            </div>
        } @else {
            <div class="progress-bar-container">
                <mat-progress-bar mode="query"></mat-progress-bar>
            </div>
        }
    </div>
}
